import { Component, OnInit, Input, ViewEncapsulation, Output, EventEmitter } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'core-touchspin',
  templateUrl: './core-touchspin.component.html',
  styleUrls: ['./core-touchspin.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CoreTouchspinComponent implements OnInit {
  @Input() set numberValue(value: number) {
    this._numberValue = value;
    this.numberInputFormControl.setValue(value);
  }
  get numberValue() {
    return this._numberValue;
  }
  @Input() iconChevron = false;
  // eslint-disable-next-line @angular-eslint/no-input-rename
  @Input('disable') disabledValue = false;
  @Input() size = '';
  @Input() color = '';
  @Input() stepValue: number;
  @Input() maxValue = 9999;
  @Input() minValue = 0;
  @Output() open: EventEmitter<any> = new EventEmitter();
  public disabledValueIncrement = false;
  public disabledValueDecrement = false;
  public numberInputFormControl = new FormControl(1);
  private _numberValue: number;
  constructor() {
  }

  inputChange(inputValue: string) {
    const parsedInputValue = parseInt(inputValue, 10);
    let emittedValue = parsedInputValue;
    if (emittedValue > this.maxValue) {
      emittedValue = this.maxValue;
    }
    if (emittedValue < this.minValue) {
      emittedValue = this.minValue;
    }
    this.disabledValueIncrement = emittedValue === this.maxValue || emittedValue > this.maxValue;
    this.disabledValueDecrement = emittedValue === this.minValue || emittedValue < this.minValue;
    this.numberInputFormControl.setValue(emittedValue);
    this.open.emit(emittedValue);
  }

  increment() {

    if (this.stepValue === undefined) {
      this.numberValue += 1;
    } else {
      this.numberValue += this.stepValue;
    }
    this.numberInputFormControl.setValue(this.numberValue);
    this.open.emit(this.numberValue);
    if (!(this.minValue === undefined || this.maxValue === undefined)) {
      if (this.numberValue === this.maxValue || this.numberValue > this.maxValue) {
        this.disabledValueIncrement = true;
      } else {
        this.disabledValueIncrement = false;
      }
      if (this.numberValue > this.minValue) {
        this.disabledValueDecrement = false;
      } else {
        this.disabledValueDecrement = true;
      }
    }
  }

  decrement() {
    if (this.stepValue === undefined) {
      this.numberValue -= 1;
    } else {
      this.numberValue -= this.stepValue;
    }
    this.numberInputFormControl.setValue(this.numberValue);
    this.open.emit(this.numberValue);
    if (!(this.minValue === undefined || this.maxValue === undefined)) {
      if (this.numberValue === this.minValue || this.numberValue < this.minValue) {
        this.disabledValueDecrement = true;
      } else {
        this.disabledValueDecrement = false;
      }
      if (this.numberValue < this.maxValue) {
        this.disabledValueIncrement = false;
      } else {
        this.disabledValueIncrement = true;
      }
    }
  }


  inputBlurHandler(value) {
    if(value === '' || isNaN(value)) {
      this.numberInputFormControl.setValue(this.minValue);
      this.numberValue = this.minValue;
    }
  }

  ngOnInit(): void {
    this.disabledValueIncrement = this.disabledValue;
    this.disabledValueDecrement = this.disabledValue;

    // Check if current value is equal to min / max value then disable button respectively
    if (this.numberValue === this.minValue) {
      this.disabledValueDecrement = true;
    } else if (this.numberValue === this.maxValue) {
      this.disabledValueIncrement = true;
    }
  }
}
